export default "__VITE_ASSET__KoDYSdwl__";